module.exports = __webpack_public_path__ + "static/media/CenterAlignBlack.fc819376.svg";